// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9eb62cad02c0b57507ff","655":"b4c89e653b70910fc8ca"}[chunkId] + ".js";
};